// Shared parsing for optional numeric inputs (e.g. capacity factor fields) where a blank
// value means "not set" rather than 0.
export function parseNullableNumber(raw: string): number | null {
  const trimmed = raw.trim();
  if (trimmed === '') return null;
  const parsed = Number(trimmed);
  return Number.isFinite(parsed) ? parsed : null;
}
